import { render, staticRenderFns } from "./SchoolInfo.vue?vue&type=template&id=143ae794&scoped=true"
import script from "./SchoolInfo.vue?vue&type=script&lang=js"
export * from "./SchoolInfo.vue?vue&type=script&lang=js"
import style0 from "./SchoolInfo.vue?vue&type=style&index=0&id=143ae794&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143ae794",
  null
  
)

export default component.exports